(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["l1h-cargo-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const mounted = new WeakMap();
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    const phase = (progress, start, end) => {
      const value = clamp((progress - start) / (end - start), 0, 1);
      return value * value * (3 - 2 * value);
    };

    function mount(root) {
      if (mounted.has(root)) return;
      const scroll = root.querySelector('[data-cargo-scroll]');
      const pin = root.querySelector('[data-cargo-pin]');
      const stage = root.querySelector('[data-cargo-stage]');
      const stagePin = root.querySelector('[data-cargo-stage-pin]');
      const canvas = root.querySelector('[data-cargo-canvas]');
      const video = root.querySelector('[data-cargo-video]');
      const videoMode = root.dataset.mediaMode === 'transparent_video';
      const media = root.querySelector('[data-cargo-media]');
      const heading = root.querySelector('[data-cargo-heading]');
      if (!scroll || !pin || !media || !heading) return;
      const ctx = canvas?.getContext('2d');
      const controller = new AbortController();
      const { signal } = controller;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const tallViewport = window.matchMedia('(min-height: 501px)');
      const mobile = window.matchMedia('(max-width: 768px)');
      const hover = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
      const features = root.querySelector('[data-cargo-features]');
      const info = root.querySelector('[data-cargo-info]');
      const details = Array.from(root.querySelectorAll('[data-cargo-feature]'));
      const stats = root.querySelector('[data-cargo-stats]');
      const statItems = Array.from(root.querySelectorAll('[data-cargo-stat]'));
      const trust = root.querySelector('[data-cargo-trust]');
      const wash = root.querySelector('[data-cargo-wash]');
      const subtitle = heading.querySelector('.l1h-description');
      const title = heading.querySelector('.l1h-heading');
      const titleWords = [];
      function splitTitleWords(node) {
        if (node.nodeType === 3) {
          node.replaceWith(...node.textContent.split(/(\s+)/).map(text => {
            if (!text.trim()) return document.createTextNode(text);
            const element = document.createElement('span');
            element.className = 'l1h-cargo-title-word';
            element.textContent = text;
            titleWords.push({ element, line: 0 });
            return element;
          }));
        } else {
          Array.from(node.childNodes).forEach(splitTitleWords);
        }
      }
      if (title) splitTitleWords(title);
      root.querySelectorAll('[data-cargo-number]').forEach(element => { element.textContent = element.dataset.cargoNumber; });
      const pattern = root.dataset.frameUrl;
      const count = Number(root.dataset.frameCount);
      const start = Number(root.dataset.frameStart);
      const padding = Number(root.dataset.framePadding);
      const validUrl = value => {
        try { return ['https:', 'http:'].includes(new URL(value).protocol); }
        catch { return false; }
      };
      const normalizeUrl = value => {
        if (typeof value !== 'string' || !value.trim()) return '';
        try { return new URL(value, window.location.href).href; }
        catch { return ''; }
      };
      const parseSources = value => {
        try {
          const sources = JSON.parse(value || '[]');
          return Array.isArray(sources) ? sources.map(normalizeUrl).filter(validUrl) : [];
        } catch { return []; }
      };
      const originalVideoUrl = (sources, extension) => {
        for (const source of parseSources(sources)) {
          const path = new URL(source).pathname;
          if (path.endsWith(`.${extension}`)) return source;
          // The picker exposes transcodes. Shopify's retained original shares
          // their video ID; using its CDN route avoids stripping the alpha track.
          const id = path.match(/\/(?:cdn\/shop\/)?videos\/c\/vp\/([a-f0-9]{32})\//i)?.[1];
          if (id) return `https://cdn.shopify.com/videos/c/o/v/${id}.${extension}`;
        }
        return '';
      };
      let videoUrl = '';
      let videoType = '';
      if (videoMode && video) {
        // WebKit needs HEVC Alpha; codec support alone does not mean alpha support.
        const webkit = /Safari/.test(navigator.userAgent) && !/Chrome|Chromium|Android/.test(navigator.userAgent);
        videoType = webkit ? 'video/mp4; codecs="hvc1"' : 'video/webm; codecs="vp9"';
        const source = webkit
          ? originalVideoUrl(video.dataset.hevcSources, 'mov')
          : originalVideoUrl(video.dataset.webmSources, 'webm');
        if (video.canPlayType(videoType) && validUrl(source)) videoUrl = source;
      }
      const validSource = videoMode ? Boolean(video && videoUrl) : Boolean(ctx && pattern?.includes('{frame}') && Number.isInteger(count) && count > 1 && count <= 1000 && Number.isInteger(start) && start >= 0 && Number.isInteger(padding) && padding >= 0 && padding <= 8 && validUrl(pattern.replaceAll('{frame}', String(start))));
      const frames = new Map();
      const loading = new Map();
      const failed = new Set();
      let queue = [];
      let requested = -1;
      let turn = 0;
      let near = false;
      let disposed = false;
      let failedSource = false;
      let animated = false;
      let frameScale = 1;
      let sceneScale = 1;
      let holdDistance = 0;
      let stageTop = 0;
      let headingInset = 24;
      let headingHeight = 0;
      let headingBase = 0;
      let pinStart = 0;
      let paintedImage = null;
      let paintedSig = '';
      let titleLineCount = 1;
      let mediaTop = 0;
      let mediaY = 0;
      let featuresVisible = false;
      let featureAnimations = [];
      let current = 0;
      let target = 0;
      let copyCurrent = 0;
      let copyTarget = 0;
      let raf = 0;
      let previousTime = 0;
      let closeTimer;
      let videoLoaded = false;
      let videoDuration = 0;
      let videoSeekTarget = null;
      let videoSeeking = false;
      let videoObjectUrl = '';
      let videoPrimed = false;
      let videoPriming = false;

      const releaseImage = image => { image.onload = null; image.onerror = null; image.removeAttribute('src'); };
      const frameUrl = index => pattern.replaceAll('{frame}', String(start + index).padStart(padding, '0'));
      const updateTargets = () => {
        if (!animated) { target = copyTarget = 1; return; }
        const mobileStage = mobile.matches && stage && stagePin;
        const track = mobileStage ? stage : scroll;
        const pinned = mobileStage ? stagePin : pin;
        // The copy starts before the product's pinned scroll timeline.
        const approach = mobileStage ? 0 : Math.min(pinned.offsetHeight * .5, 400);
        const top = track.getBoundingClientRect().top;
        const distance = (mobileStage ? stageTop : approach) - top;
        const span = Math.max(1, track.offsetHeight - pinned.offsetHeight - holdDistance + approach);
        // Progress at which the stage pins; desktop phases are anchored to it so a shorter track keeps the same choreography.
        pinStart = approach / span;
        target = clamp(distance / span, 0, 1);
        // Mobile copy approaches before the bike pins. Sample both targets before
        // rendering, then ease them on the same clock without starting rotation early.
        copyTarget = mobile.matches
          ? .14 * clamp((window.innerHeight - top) / (window.innerHeight * .35), 0, 1)
          : clamp((window.innerHeight * .8 - top) / span, 0, 1);
      };
      // Keep each pose aligned with its final hotspot positions.
      const frameOffset = () => mobile.matches ? .055 : animated ? -.1275 : -.048;

      function positionVideo() {
        if (videoMode && video) video.style.transform = `translateY(${frameOffset() * 100}%) scale(${frameScale})`;
      }

      const mobileStill = () => mobile.matches && !animated;

      function showVideoFrame() {
        if (mobileStill() || disposed || !near || document.hidden || failedSource || !videoPrimed || !video.paused || videoSeekTarget !== null || videoSeeking || video.seeking || video.readyState < 2) return;
        root.classList.add('has-cargo-video');
        video.removeAttribute('aria-hidden');
      }

      function flushVideoSeek() {
        if (disposed || !near || document.hidden || failedSource || !videoPrimed || !videoDuration || videoSeekTarget === null || videoSeeking || video.seeking) return;
        const time = videoSeekTarget;
        videoSeekTarget = null;
        // A seek within half a 60fps frame lands on the same picture; skip it to keep the decoder free.
        if (Math.abs(video.currentTime - time) < .008) return;
        try {
          videoSeeking = true;
          video.currentTime = time;
        } catch {
          videoSeeking = false;
          videoSeekTarget = time;
        }
      }

      async function primeVideo() {
        if (disposed || !near || document.hidden || failedSource || !videoObjectUrl || videoPrimed || videoPriming) return;
        videoPriming = true;
        try {
          await video.play();
          if (disposed || failedSource) return;
          video.pause();
          videoPrimed = true;
        } catch (error) {
          if (error.name !== 'AbortError' && !disposed && !failedSource && near && !document.hidden) failVideo();
        } finally {
          videoPriming = false;
        }
        if (videoPrimed && !disposed && !failedSource) requestBike(turn);
      }

      async function loadVideoSource() {
        try {
          // A complete, typed Blob keeps alpha and seeking intact even when
          // the CDN's MIME type or seekable range is inconsistent.
          const response = await fetch(videoUrl, { signal });
          if (!response.ok) throw new Error('Video could not be loaded');
          const blob = await response.blob();
          if (disposed || failedSource) return;
          videoObjectUrl = URL.createObjectURL(blob.slice(0, blob.size, videoType));
          video.src = videoObjectUrl;
          video.load();
          primeVideo();
        } catch {
          if (!disposed) failVideo();
        }
      }

      function requestVideo(value) {
        if (!validSource || !near || document.hidden || failedSource || disposed) return;
        if (!videoLoaded) {
          videoLoaded = true;
          video.muted = true;
          video.playsInline = true;
          video.controls = false;
          video.pause();
          video.preload = 'auto';
          loadVideoSource();
        }
        primeVideo();
        if (!videoDuration) return;
        videoSeekTarget = Math.min(value * videoDuration, Math.max(0, videoDuration - .001));
        flushVideoSeek();
        showVideoFrame();
      }

      if (videoMode && video) {
        ['play', 'playing'].forEach(type => video.addEventListener(type, () => {
          // Only the hidden first-frame warm-up may play. Once primed, the
          // scroll position owns the video, including before the stage pins.
          if (!videoPrimed || disposed || failedSource) return;
          video.pause();
          requestBike(turn);
        }, { signal }));
        video.addEventListener('loadedmetadata', () => {
          if (!videoLoaded || failedSource) return;
          const duration = video.duration;
          if (!Number.isFinite(duration) || duration <= 0) { failVideo(); return; }
          videoDuration = duration;
          requestBike(turn);
        }, { signal });
        ['loadeddata', 'canplay', 'seeked'].forEach(type => video.addEventListener(type, () => {
          if (type === 'seeked') videoSeeking = false;
          if (!videoLoaded || failedSource) return;
          requestBike(turn);
        }, { signal }));
        video.addEventListener('error', failVideo, { signal });
      }

      function failVideo() {
        if (disposed || failedSource || !videoLoaded) return;
        videoLoaded = false;
        videoDuration = 0;
        videoSeekTarget = null;
        videoSeeking = false;
        videoPrimed = false;
        root.classList.remove('has-cargo-video');
        video.setAttribute('aria-hidden', 'true');
        video.pause();
        video.removeAttribute('src');
        video.load();
        if (videoObjectUrl) URL.revokeObjectURL(videoObjectUrl);
        videoObjectUrl = '';
        failedSource = true;
        updateMode();
      }

      function paint() {
        if (mobileStill() || !ctx || !frames.size || disposed) return;
        let nearest = -1;
        frames.forEach((_, index) => { if (nearest < 0 || Math.abs(index - requested) < Math.abs(nearest - requested)) nearest = index; });
        const image = frames.get(nearest);
        // The same pose at the same size is already on the canvas.
        const sig = `${canvas.width}x${canvas.height}|${frameScale}|${frameOffset()}`;
        if (image === paintedImage && sig === paintedSig) return;
        paintedImage = image;
        paintedSig = sig;
        const scale = Math.min(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight) * frameScale;
        const width = image.naturalWidth * scale;
        const height = image.naturalHeight * scale;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, (canvas.width - width) / 2, (canvas.height - height) / 2 + canvas.height * frameOffset(), width, height);
        root.classList.add('has-cargo-frame');
        canvas.removeAttribute('aria-hidden');
      }

      function trimFrames() {
        const limit = mobile.matches ? 6 : 24;
        const removable = Array.from(frames.keys()).filter(index => index !== 0 && index !== count - 1 && index !== requested).sort((a, b) => Math.abs(b - requested) - Math.abs(a - requested));
        while (frames.size > limit && removable.length) {
          const index = removable.shift();
          releaseImage(frames.get(index));
          frames.delete(index);
        }
      }

      function pump() {
        if (disposed || !near) return;
        while (loading.size < (mobile.matches ? 3 : 6) && queue.length) {
          const index = queue.shift();
          if (frames.has(index) || loading.has(index) || failed.has(index)) continue;
          const image = new Image();
          image.decoding = 'async';
          loading.set(index, image);
          const finish = success => {
            if (disposed) { releaseImage(image); return; }
            image.onload = null;
            image.onerror = null;
            loading.delete(index);
            if (success) { frames.set(index, image); trimFrames(); paint(); }
            else {
              failed.add(index);
              releaseImage(image);
              if (!frames.size && failed.has(0) && failed.has(count - 1)) { failedSource = true; queue = []; updateMode(); }
            }
            pump();
          };
          image.onload = () => image.decode().then(() => finish(true), () => finish(false));
          image.onerror = () => finish(false);
          image.src = frameUrl(index);
        }
      }

      function requestBike(value) {
        turn = value;
        if (mobileStill()) return;
        if (videoMode) {
          positionVideo();
          requestVideo(value);
          return;
        }
        if (!validSource || !near || failedSource || disposed) return;
        const index = Math.round(value * (count - 1));
        if (index !== requested) {
          // Load ahead of the scroll direction first so fast scrolling still finds nearby poses.
          const direction = requested < 0 || index >= requested ? 1 : -1;
          requested = index;
          const candidates = [index];
          if (animated) {
            candidates.push(0, count - 1);
            for (let step = 1; step <= (mobile.matches ? 3 : 8); step++) {
              candidates.push(index + direction * step);
              if (step <= 3) candidates.push(index - direction * step);
            }
          }
          queue = [...new Set(candidates)].filter(item => item >= 0 && item < count && !frames.has(item) && !loading.has(item) && !failed.has(item));
          pump();
        }
        paint();
      }

      function positionPanel(detail) {
        detail.removeAttribute('data-cargo-panel-above');
        const panel = detail.querySelector('[data-cargo-panel]');
        if (!panel) return;
        panel.style.removeProperty('left');
        panel.style.removeProperty('top');
        panel.style.removeProperty('max-height');
        panel.style.removeProperty('overflow-y');
        if (!animated || mobile.matches || !detail.open) return;
        const label = detail.querySelector('summary').getBoundingClientRect();
        const bounds = pin.getBoundingClientRect();
        const gap = 6 * sceneScale;
        const top = Math.max(12, bounds.top + 12);
        const bottom = Math.min(window.innerHeight - 12, (stats?.getBoundingClientRect().top ?? bounds.bottom) - gap);
        const below = Math.max(0, bottom - label.bottom - gap);
        const above = Math.max(0, label.top - top - gap);
        const useAbove = detail.hasAttribute('data-open-above') ? above >= panel.offsetHeight || above > below : below < panel.offsetHeight && above > below;
        if (useAbove) detail.setAttribute('data-cargo-panel-above', '');
        const available = useAbove ? above : below;
        panel.style.maxHeight = `${Math.max(44, available)}px`;
        panel.style.overflowY = 'auto';
        panel.style.left = `${clamp(label.left, 12, Math.max(12, window.innerWidth - panel.offsetWidth - 12)) - label.left}px`;
        panel.style.top = `${useAbove ? -panel.offsetHeight - gap : label.height + gap}px`;
      }

      function closeFeatures() {
        window.clearTimeout(closeTimer);
        details.forEach(detail => { detail.open = false; });
      }

      function openFeature(detail) {
        if (!detail || features?.inert) return;
        window.clearTimeout(closeTimer);
        details.forEach(other => { if (other !== detail) other.open = false; });
        detail.open = true;
        positionPanel(detail);
      }

      details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (mobile.matches) return;
          if (detail.open) openFeature(detail);
        }, { signal });
        detail.querySelector('summary')?.addEventListener('click', event => {
          if (mobile.matches) {
            event.preventDefault();
            const shouldOpen = !detail.open;
            const useDetailsContent = CSS.supports('selector(::details-content)');
            const setMotion = (target, height, opacity) => {
              if (useDetailsContent) {
                target.style.setProperty('--cargo-details-height', height);
                target.style.setProperty('--cargo-details-opacity', opacity);
                return;
              }
              const panel = target.querySelector('[data-cargo-panel]');
              if (!panel) return;
              panel.style.height = height;
              panel.style.opacity = opacity;
            };
            const animateDisclosure = (target, open) => {
              const token = (target._cargoMotionToken || 0) + 1;
              target._cargoMotionToken = token;
              const panel = target.querySelector('[data-cargo-panel]');
              if (open) {
                target.classList.remove('is-closing');
                target.open = true;
                if (useDetailsContent) target.style.setProperty('--cargo-details-height', 'auto');
                const next = panel ? `${panel.scrollHeight}px` : '0px';
                setMotion(target, '0px', '0');
                void target.offsetHeight;
                requestAnimationFrame(() => {
                  if (target._cargoMotionToken !== token) return;
                  setMotion(target, next, '1');
                });
                return;
              }
              const current = panel ? `${Math.max(0, Math.round(panel.getBoundingClientRect().height))}px` : '0px';
              setMotion(target, current, '1');
              target.classList.add('is-closing');
              const motionHeight = () => {
                if (useDetailsContent) return parseFloat(getComputedStyle(target, '::details-content').height) || 0;
                const content = target.querySelector('[data-cargo-panel]');
                return content ? content.getBoundingClientRect().height : 0;
              };
              const finish = () => {
                if (target._cargoMotionToken !== token) return;
                if (motionHeight() > 0.5) {
                  requestAnimationFrame(finish);
                  return;
                }
                target.open = false;
                target.classList.remove('is-closing');
                target.style.removeProperty('--cargo-details-height');
                target.style.removeProperty('--cargo-details-opacity');
                const content = target.querySelector('[data-cargo-panel]');
                if (content) {
                  content.style.removeProperty('height');
                  content.style.removeProperty('opacity');
                }
              };
              requestAnimationFrame(() => {
                if (target._cargoMotionToken !== token) return;
                setMotion(target, '0px', '0');
                requestAnimationFrame(finish);
              });
            };
            if (shouldOpen) details.forEach(other => { if (other !== detail && other.open) animateDisclosure(other, false); });
            animateDisclosure(detail, shouldOpen);
            return;
          }
          // Hover already opened the panel; only mouse activation skips the native toggle.
          if (hover.matches && detail.open && event.detail > 0 && (!event.pointerType || event.pointerType === 'mouse')) event.preventDefault();
        }, { signal });
        detail.addEventListener('pointerenter', event => { if (hover.matches && event.pointerType !== 'touch') openFeature(detail); }, { signal });
        detail.addEventListener('pointerleave', event => {
          if (!hover.matches || event.pointerType === 'touch') return;
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => { if (!detail.contains(document.activeElement)) detail.open = false; }, 160);
        }, { signal });
        detail.addEventListener('focusout', event => { if (!mobile.matches && !detail.contains(event.relatedTarget)) detail.open = false; }, { signal });
        detail.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); detail.open = false; }
        }, { signal });
      });
      root.addEventListener('pointerdown', event => { if (!mobile.matches && !event.target.closest('[data-cargo-feature]')) closeFeatures(); }, { signal });

      function render(value) {
        const desktopAnimation = animated && !mobile.matches;
        // Desktop phases follow the pin point, so shortening the track compresses them together.
        const rotationStart = mobile.matches ? 0 : pinStart + .1;
        const rotationEnd = mobile.matches ? .76 : .94;
        const rotation = animated ? phase(value, rotationStart, rotationEnd) : 1;
        const entrance = desktopAnimation ? phase(copyCurrent, .14, .24) : 1;
        const push = desktopAnimation ? phase(value, pinStart + .01, rotationStart) : 1;
        // Desktop arrivals have their own clock as soon as the last pose is reached.
        const showFeatures = !animated || (mobile.matches ? value >= .82 : rotation === 1);
        const reveal = Number(showFeatures);
        if (desktopAnimation) {
          // Fade in just below the copy with a small rise, then settle into the
          // final stage while the copy exits. Never lift the bike from offscreen.
          const introY = Math.max(0, headingInset + headingHeight + 24 - mediaTop);
          mediaY = introY * (1 - push) + (1 - entrance) * 24;
          media.style.transform = `translateY(${mediaY}px)`;
          // CSS sticky keeps the copy at its top inset. Never compensate for the
          // live scroll position here: it lags the compositor and makes the title shake.
          // The media clips every frame, so its top is a safe boundary even when
          // transparent video padding, image scale or the copy's line count changes.
          // The intro pose already clears the inset, so only the exit can bind it.
          const clearTop = mediaTop + mediaY - headingHeight - 24;
          const headingShift = Math.min(-push * 24, clearTop - headingInset);
          heading.style.transform = `translateY(${headingShift - headingBase}px)`;
          heading.style.opacity = String(1 - push);
        } else {
          mediaY = 0;
          media.style.removeProperty('transform');
          heading.style.removeProperty('transform');
          heading.style.removeProperty('opacity');
        }
        if (animated) {
          titleWords.forEach(({ element, line }) => {
            const delay = .035 * line / Math.max(1, titleLineCount - 1);
            const entrance = phase(copyCurrent, delay, delay + .075);
            element.style.opacity = String(entrance);
            element.style.transform = `translateY(${(1 - entrance) * 28}px)`;
          });
          if (subtitle) {
            const entrance = phase(copyCurrent, .08, .14);
            subtitle.style.opacity = String(entrance);
            subtitle.style.transform = `translateY(${(1 - entrance) * 20}px)`;
          }
        } else {
          subtitle?.style.removeProperty('opacity');
          subtitle?.style.removeProperty('transform');
          titleWords.forEach(({ element }) => {
            element.style.removeProperty('opacity');
            element.style.removeProperty('transform');
          });
        }
        media.style.opacity = String(entrance);
        if (wash) wash.style.opacity = String(animated ? (mobile.matches ? 1 : phase(value, Math.max(0, pinStart - .04), .94)) : 0);
        if (features) {
          // Visibility and interaction switch together; no disabled fade-in state.
          features.style.opacity = showFeatures ? '1' : '0';
          features.style.visibility = showFeatures ? 'visible' : 'hidden';
          features.inert = !showFeatures;
          features.setAttribute('aria-hidden', String(!showFeatures));
        }
        if (trust) {
          trust.style.opacity = String(reveal);
          trust.style.visibility = reveal > 0 ? 'visible' : 'hidden';
          trust.style.transform = `translateY(${(1 - reveal) * 16}px)`;
        }
        if (stats) {
          stats.style.opacity = showFeatures ? '1' : '0';
          stats.style.visibility = showFeatures ? 'visible' : 'hidden';
        }
        if (!desktopAnimation || !showFeatures) {
          featureAnimations.forEach(animation => animation.cancel());
          featureAnimations = [];
        } else if (near && !document.hidden) {
          const keyframes = [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0px)' }];
          if (!featuresVisible || !featureAnimations.length) {
            const arrivals = [...details];
            if (trust) arrivals.push(trust);
            arrivals.push(...statItems);
            featureAnimations = arrivals.map((element, index) => element.animate(keyframes, {
              duration: 350, delay: index * 50, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'
            }));
          }
        }
        if (!showFeatures) closeFeatures();
        featuresVisible = showFeatures;
        requestBike(rotation);
      }

      function tick(time) {
        raf = 0;
        if (disposed || !near || document.hidden) return;
        const delta = previousTime ? Math.min(64, time - previousTime) : 16;
        previousTime = time;
        const smoothing = 1 - Math.exp(-delta / 90);
        const distance = target - current;
        const copyDistance = copyTarget - copyCurrent;
        current = Math.abs(distance) < .00015 ? target : current + distance * smoothing;
        copyCurrent = Math.abs(copyDistance) < .00015 ? copyTarget : copyCurrent + copyDistance * smoothing;
        render(current);
        if (current !== target || copyCurrent !== copyTarget) raf = window.requestAnimationFrame(tick);
        else previousTime = 0;
      }

      function queueScene() {
        updateTargets();
        if (near && !document.hidden && !raf) raf = window.requestAnimationFrame(tick);
      }

      function layout() {
        if (disposed) return;
        const styles = getComputedStyle(root);
        frameScale = Number.parseFloat(styles.getPropertyValue('--cargo-image-scale'));
        if (!Number.isFinite(frameScale) || frameScale <= 0) frameScale = 1;
        sceneScale = animated && !mobile.matches ? Math.min(1, pin.clientWidth / 1920, pin.clientHeight / 940) : 1;
        root.style.setProperty('--cargo-unit', `${sceneScale}px`);
        holdDistance = window.innerHeight * (Number.parseFloat(styles.getPropertyValue('--cargo-hold-ratio')) || 0);
        root.style.setProperty('--cargo-hold-distance', `${holdDistance}px`);
        // Reserve the mobile cards' flow space without changing the scrub distance.
        root.style.setProperty('--cargo-info-height', `${animated && mobile.matches ? info?.offsetHeight || 0 : 0}px`);
        stageTop = stagePin ? Number.parseFloat(getComputedStyle(stagePin).top) || 0 : 0;
        headingInset = Math.max(24, Number.parseFloat(styles.paddingTop) || 0);
        const lineTops = [...new Set(titleWords.map(({ element }) => element.offsetTop))];
        headingHeight = heading.offsetHeight;
        // The title sits at the top of the presentation. Its own offsetTop includes the sticky shift, so it is left out.
        headingBase = heading.offsetParent?.offsetTop || 0;
        root.style.setProperty('--cargo-heading-top', `${headingInset + headingBase}px`);
        titleLineCount = lineTops.length;
        titleWords.forEach(word => { word.line = lineTops.indexOf(word.element.offsetTop); });
        const width = Math.max(1, Math.min(1920, Math.round(media.clientWidth * Math.min(window.devicePixelRatio || 1, 2))));
        const height = Math.max(1, Math.round(width * media.clientHeight / Math.max(1, media.clientWidth)));
        if (canvas && (canvas.width !== width || canvas.height !== height)) { canvas.width = width; canvas.height = height; }
        if (animated && !mobile.matches) {
          mediaTop = media.getBoundingClientRect().top - pin.getBoundingClientRect().top - mediaY;
        }
        positionVideo();
        paint();
        details.forEach(positionPanel);
        queueScene();
      }

      function updateMode() {
        const usableSource = validSource && !failedSource;
        const hasPoster = root.querySelector('.l1h-cargo-poster img') && (mobile.matches || !root.querySelector('.l1h-cargo-poster--mobile-only'));
        animated = usableSource && !reduced.matches && tallViewport.matches && (!mobile.matches || root.dataset.mobileScrollAnimation === 'true');
        if (mobileStill()) {
          root.classList.remove('has-cargo-video', 'has-cargo-frame');
          video?.pause();
          video?.setAttribute('aria-hidden', 'true');
          canvas?.setAttribute('aria-hidden', 'true');
        }
        media.hidden = !usableSource && !hasPoster;
        root.classList.toggle('is-cargo-animated', animated);
        requested = -1;
        paintedImage = null;
        closeFeatures();
        featuresVisible = false;
        layout();
        current = target;
        copyCurrent = copyTarget;
        render(current);
      }

      const resizeObserver = new ResizeObserver(layout);
      resizeObserver.observe(media);
      resizeObserver.observe(pin);
      resizeObserver.observe(heading);
      if (stagePin) resizeObserver.observe(stagePin);
      if (info) resizeObserver.observe(info);
      const observer = new IntersectionObserver(entries => {
        near = entries[0].isIntersecting;
        if (near) {
          requested = -1;
          queueScene();
          current = target;
          copyCurrent = copyTarget;
          render(current);
        }
        else { window.cancelAnimationFrame(raf); raf = 0; previousTime = 0; queue = []; video?.pause(); }
      }, { rootMargin: '600px 0px' });
      observer.observe(scroll);
      window.addEventListener('scroll', () => {
        if (!mobile.matches && details.some(detail => detail.open) && !features?.contains(document.activeElement)) closeFeatures();
        queueScene();
      }, { passive: true, signal });
      window.addEventListener('resize', layout, { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          window.cancelAnimationFrame(raf);
          raf = 0;
          previousTime = 0;
          video?.pause();
        } else if (near) {
          queueScene();
          current = target;
          copyCurrent = copyTarget;
          render(current);
        }
      }, { signal });
      [reduced, tallViewport, mobile].forEach(query => query.addEventListener('change', updateMode, { signal }));
      document.fonts.ready.then(() => { if (!disposed) layout(); });
      root.addEventListener('shopify:block:select', event => {
        const detail = event.target.closest('[data-cargo-feature]');
        if (!detail) return;
        if (animated) {
          const track = mobile.matches && stage ? stage : scroll;
          const pinned = mobile.matches && stagePin ? stagePin : pin;
          const travel = Math.max(0, track.offsetHeight - pinned.offsetHeight - holdDistance);
          window.scrollTo({ top: window.scrollY + track.getBoundingClientRect().top + travel - (mobile.matches ? stageTop : 0), behavior: 'instant' });
          current = target = 1;
          copyCurrent = copyTarget = mobile.matches ? .14 : 1;
          render(1);
        }
        openFeature(detail);
      }, { signal });
      mounted.set(root, () => {
        disposed = true;
        controller.abort();
        observer.disconnect();
        resizeObserver.disconnect();
        window.cancelAnimationFrame(raf);
        window.clearTimeout(closeTimer);
        featureAnimations.forEach(animation => animation.cancel());
        titleWords.forEach(({ element }) => element.replaceWith(document.createTextNode(element.textContent)));
        loading.forEach(releaseImage);
        frames.forEach(releaseImage);
        loading.clear();
        frames.clear();
        queue = [];
        if (videoMode && video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
          if (videoObjectUrl) URL.revokeObjectURL(videoObjectUrl);
          root.classList.remove('has-cargo-video');
          video.setAttribute('aria-hidden', 'true');
        }
      });
      updateMode();
    }

    function mountAll(container) {
      if (container.matches?.('[data-l1h-cargo]')) mount(container);
      container.querySelectorAll('[data-l1h-cargo]').forEach(mount);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(document), { once: true });
    else mountAll(document);
    document.addEventListener('shopify:section:load', event => mountAll(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-l1h-cargo]').forEach(root => { mounted.get(root)?.(); mounted.delete(root); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["l1h-section-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const mounted = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function layoutButton(button) {
      const width = button.getBoundingClientRect().width;
      // 按钮高度基准为 48px，PC 端高度随 --l1h-k 连续变化，因此用实际高度推导缩放比例。
      const scale = button.getBoundingClientRect().height / 48;
      const svg = button.querySelector('.l1h-button__shape');
      const group = svg?.querySelector('g');
      const path = svg?.querySelector('path');
      if (!width || !scale || !group || !path) return;
      const w = width / scale;
      const r = w - 4;
      const rest = `M39.3147 45.5877C38.6814 47.052 37.2386 48 35.6432 48H4C1.79086 48 0 46.2091 0 44V4C0 1.79086 1.79086 0 4 0H52.9406C55.8179 0 57.7541 2.94673 56.612 5.58765L39.3147 45.5877ZM${w} 44C${w} 46.2091 ${w-1.79086} 48 ${r} 48H52.784C49.9067 48 47.9706 45.0533 49.1126 42.4123L66.4099 2.41235C67.0432 .948021 68.486 0 70.0814 0H${r}C${w-1.79086} 0 ${w} 1.79086 ${w} 4V44Z`;
      const joined = `M44 48C44 48 44 48 44 48H4C1.79086 48 0 46.2091 0 44V4C0 1.79086 1.79086 0 4 0H65C65 0 65 0 65 0L44 48ZM${w} 44C${w} 46.2091 ${w-1.79086} 48 ${r} 48H43.5C43.5 48 43.5 48 43.5 48L64.5 0C64.5 0 64.5 0 64.5 0H${r}C${w-1.79086} 0 ${w} 1.79086 ${w} 4V44Z`;
      svg.setAttribute('viewBox', `0 0 ${w} 48`);
      group.setAttribute('transform', `translate(${w} 0) scale(-1 1)`);
      path.setAttribute('d', rest);
      path.style.setProperty('--shape-rest', `path("${rest}")`);
      path.style.setProperty('--shape-hover', `path("${joined}")`);
    }

    function mount(root) {
      if (mounted.has(root)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const cleanups = [];
      const signupForm = root.querySelector('.l1h-signup-form');
      const signupReturnTo = signupForm?.querySelector('input[name="return_to"]');
      if (signupReturnTo) {
        const updateSignupReturnTo = () => {
          const url = new URL(window.location.href);
          url.searchParams.set('customer_posted', 'true');
          url.hash = root.id;
          signupReturnTo.value = `${url.pathname}${url.search}${url.hash}`;
        };
        updateSignupReturnTo();
        signupForm.addEventListener('submit', updateSignupReturnTo, { signal });
      }
      const heroCopy = root.querySelector('.l1h-hero-copy');
      if (heroCopy) {
        const mobileViewport = window.matchMedia('(max-width: 768px)');
        let viewportWidth = window.innerWidth;
        let resizeFrame = null;

        const clearHeight = () => {
          root.style.removeProperty('min-height');
          heroCopy.style.removeProperty('min-height');
        };
        const lockMobileHeight = () => {
          resizeFrame = null;
          if (signal.aborted || !root.isConnected) return;

          // 先恢复 CSS 高度再测量，避免再次读取上一次锁定的像素值。
          clearHeight();
          if (!mobileViewport.matches) return;
          const height = Number.parseFloat(window.getComputedStyle(root).minHeight);
          if (!Number.isFinite(height) || height <= 0) return;

          // 飞书等内置浏览器可能重新计算 svh；锁定首屏高度，保留内容自然撑高的能力。
          root.style.minHeight = `${height}px`;
          heroCopy.style.minHeight = `${height}px`;
        };
        window.addEventListener('resize', () => {
          // 仅宽度变化时重新适配，忽略工具栏和软键盘引起的高度变化。
          if (window.innerWidth === viewportWidth) return;
          viewportWidth = window.innerWidth;
          // 同一帧的多次 resize 只测量一次，并使用最终的窗口尺寸。
          if (resizeFrame === null) resizeFrame = window.requestAnimationFrame(lockMobileHeight);
        }, { passive: true, signal });
        cleanups.push(() => {
          // 编辑器卸载时由现有流程移除监听，同时取消待执行测量并恢复 CSS。
          if (resizeFrame !== null) window.cancelAnimationFrame(resizeFrame);
          clearHeight();
        });
        lockMobileHeight();
      }
      const wordmark = root.querySelector('[data-l1h-wordmark]');
      if (wordmark) {
        const originalText = wordmark.textContent;
        let attempts = 0;
        let timer;
        let animationMedia;
        const animateWordmark = () => {
          if (signal.aborted || !wordmark.isConnected) return;
          if (!window.gsap || !window.ScrollTrigger) {
            if (++attempts < 40) timer = window.setTimeout(animateWordmark, 100);
            return;
          }
          const characters = Array.from(originalText, character => {
            const span = document.createElement('span');
            span.className = 'l1h-wordmark-character';
            span.textContent = character === ' ' ? '\u00a0' : character;
            return span;
          });
          if (!characters.length) return;
          wordmark.replaceChildren(...characters);
          window.gsap.registerPlugin(window.ScrollTrigger);
          animationMedia = window.gsap.matchMedia();
          animationMedia.add('(prefers-reduced-motion: no-preference)', () => {
            const animation = window.gsap.fromTo(characters, { autoAlpha: 0, yPercent: 100 }, {
              autoAlpha: 1,
              yPercent: 0,
              duration: 0.8,
              ease: 'back.out(1.7)',
              stagger: 0.1,
              scrollTrigger: { trigger: wordmark, start: 'top 70%', toggleActions: 'play none none none', once: true }
            });
            document.fonts.ready.then(() => {
              if (!signal.aborted && !reducedMotion.matches) animation.scrollTrigger?.refresh();
            });
          }, root);
        };
        cleanups.push(() => {
          window.clearTimeout(timer);
          animationMedia?.revert();
          wordmark.textContent = originalText;
        });
        animateWordmark();
      }
      root.addEventListener('shopify:block:select', event => {
        const details = event.target.closest('.l1h-spec-group');
        if (details) details.open = true;
      }, { signal });
      const buttons = root.querySelectorAll('[data-l1h-button]');
      if (buttons.length) {
        const observer = new ResizeObserver(entries => entries.forEach(({ target }) => layoutButton(target)));
        buttons.forEach(button => { layoutButton(button); observer.observe(button); });
        cleanups.push(() => observer.disconnect());
        document.fonts.ready.then(() => buttons.forEach(button => { if (button.isConnected) layoutButton(button); }));
      }

      const syncVideos = [];
      root.querySelectorAll('[data-l1h-autoplay-video]').forEach(wrapper => {
        const mobile = window.matchMedia('(max-width: 768px)');
        const poster = wrapper.querySelector('[data-l1h-poster]');
        let activeTemplate;
        let video;
        let visible = false;

        const syncPlayback = () => {
          if (!video) return;
          if (!visible || wrapper.closest('[hidden]') || document.hidden || reducedMotion.matches) {
            video.pause();
            return;
          }
          if (!video.paused) return;
          const currentVideo = video;
          video.play().catch(() => {
            if (!signal.aborted && video === currentVideo && poster) poster.hidden = false;
          });
        };
        const selectVideo = () => {
          const template = (mobile.matches && wrapper.querySelector('[data-l1h-video-mobile]')) || wrapper.querySelector('[data-l1h-video-desktop]');
          if (template === activeTemplate) return;
          activeTemplate = template;
          video?.pause();
          video?.remove();
          video = template?.content.firstElementChild?.cloneNode(true);
          wrapper.hidden = !video;
          if (poster) poster.hidden = false;
          if (!video) return;
          video.muted = true;
          video.playsInline = true;
          video.loop = true;
          video.controls = false;
          const currentVideo = video;
          video.addEventListener('playing', () => {
            if (video === currentVideo && poster) poster.hidden = true;
          }, { signal });
          wrapper.append(video);
          syncPlayback();
        };
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          syncPlayback();
        });
        observer.observe(wrapper);
        mobile.addEventListener('change', selectVideo, { signal });
        reducedMotion.addEventListener('change', syncPlayback, { signal });
        document.addEventListener('visibilitychange', syncPlayback, { signal });
        cleanups.push(() => { observer.disconnect(); video?.pause(); });
        syncVideos.push(syncPlayback);
        selectVideo();
      });

      const tabs = Array.from(root.querySelectorAll('[data-l1h-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-l1h-panel]'));
      if (tabs.length && panels.length) {
        root.style.setProperty('--l1h-tab-count', tabs.length);
        const placeIndicator = index => {
          const tab = tabs[index];
          const list = tab?.parentElement;
          if (!tab || !list) return;
          const listBox = list.getBoundingClientRect();
          const tabBox = tab.getBoundingClientRect();
          root.style.setProperty('--l1h-tab-left', `${tabBox.left - listBox.left}px`);
          root.style.setProperty('--l1h-tab-width', `${tabBox.width}px`);
        };
        const activate = (index, focus = false) => {
          if (!tabs[index]) return;
          const key = tabs[index].dataset.l1hTab;
          root.style.setProperty('--l1h-tab-index', index);
          placeIndicator(index);
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
          });
          panels.forEach(panel => {
            panel.hidden = panel.dataset.l1hPanel !== key;
            // Panels share a grid cell; only the selected panel is interactive.
            panel.inert = panel.hidden;
            panel.setAttribute('aria-hidden', String(panel.hidden));
            if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
          });
          syncVideos.forEach(sync => sync());
          if (focus) tabs[index].focus();
          root.querySelectorAll('[data-l1h-button]').forEach(layoutButton);
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(index), { signal });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(next, true);
          }, { signal });
        });
        root.addEventListener('shopify:block:select', event => {
          const selected = event.target.closest('[data-l1h-scenario]');
          const index = tabs.findIndex(tab => tab.dataset.l1hTab === selected?.dataset.l1hScenario || tab.dataset.blockId === event.detail?.blockId);
          if (index >= 0) activate(index);
        }, { signal });
        activate(0);
        root.dataset.l1hTabsReady = '';
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => {
            const index = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
            placeIndicator(index < 0 ? 0 : index);
          });
          tabs.forEach(tab => observer.observe(tab));
          cleanups.push(() => observer.disconnect());
        }
        cleanups.push(() => {
          delete root.dataset.l1hTabsReady;
          root.style.removeProperty('--l1h-tab-count');
          root.style.removeProperty('--l1h-tab-index');
          root.style.removeProperty('--l1h-tab-left');
          root.style.removeProperty('--l1h-tab-width');
        });
      }

      root.querySelectorAll('[data-l1h-carousel]').forEach(scroller => {
        const previous = root.querySelector('[data-l1h-previous]');
        const next = root.querySelector('[data-l1h-next]');
        if (!previous || !next) return;
        let swiper;
        let timer;
        let attempts = 0;
        const initSwiper = () => {
          if (signal.aborted || !scroller.isConnected || swiper) return;
          if (!window.Swiper) {
            if (++attempts < 40) timer = window.setTimeout(initSwiper, 100);
            return;
          }
          swiper = new window.Swiper(scroller, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            breakpoints: { 769: { spaceBetween: 20 } },
            speed: reducedMotion.matches ? 0 : 400,
            grabCursor: false,
            threshold: 5,
            shortSwipes: true,
            longSwipesRatio: 0.1,
            mousewheel: { forceToAxis: true, releaseOnEdges: true },
            keyboard: { enabled: true, onlyInViewport: true, pageUpDown: false },
            navigation: { prevEl: previous, nextEl: next },
            a11y: {
              prevSlideMessage: previous.getAttribute('aria-label'),
              nextSlideMessage: next.getAttribute('aria-label')
            }
          });
        };
        reducedMotion.addEventListener('change', () => {
          if (!swiper) return;
          swiper.params.speed = swiper.originalParams.speed = reducedMotion.matches ? 0 : 400;
        }, { signal });
        cleanups.push(() => {
          window.clearTimeout(timer);
          swiper?.destroy(true, true);
        });
        initSwiper();
      });
      mounted.set(root, () => { controller.abort(); cleanups.forEach(cleanup => cleanup()); });
    }

    function mountAll(container) {
      if (container.matches?.('[data-l1h-section]')) mount(container);
      container.querySelectorAll('[data-l1h-section]').forEach(mount);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(document), { once: true });
    else mountAll(document);
    document.addEventListener('shopify:section:load', event => mountAll(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-l1h-section]').forEach(root => { mounted.get(root)?.(); mounted.delete(root); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
